<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "HomeSite",
  data() {
    return {
      component: "DashboardSite",
    };
  },
  props: {
    area: {
      default: "dashboard",
      type: String,
    },
  },
  components: {},
  methods: {
    link(link) {
      this.goTo("/home/" + link);
    },
  },
  computed: {},
  created() {
    this.$store.dispatch("header/updateTab", 0);
    this.$store.dispatch("header/update", {
      bg: "bg-primary-500",
      css: "text-black",
      tabs: {
        elements: [
          {
            bright: false,
            title: this.$t("home.home"),
            action: () => {
              this.link("dashboard");
            },
          },
          {
            bright: false,
            title: this.$t("home.news"),
            action: () => {
              this.link("news");
            },
          },
        ],
      },
    });
  },
};
</script>
